"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var removeCode = function removeCode(id) {
  if (!id) return;
  var element = document.getElementById("mco-tracking--".concat(id));
  if (!element) return;
  element.remove();
};

var _default = removeCode;
exports.default = _default;